jQuery(window).on('beforeunload', function ($) {
    $(window).scrollTop(0);
});

jQuery(document).ready(function ($) {
    setTimeout(function () {
        $('.custom-banner .wave-banner').css('right', '-35%');
    }, 1500);
    setTimeout(function () {
        $('.custom-banner .img-banner').css('opacity', '1');
    }, 2000);
    // setTimeout(function () {
    //     $('.theme-preloader').fadeOut();
    // }, 1000);
    $(window).scrollTop(0);

    function updateVH() {
        let browserHeight = $(window).height();
        let computation = browserHeight / 100;
        $('body').css('--vh', computation + 'px');
    }

    updateVH();

    $(window).on('resize', function () {
        updateVH();
    });

    function animateSections() {
        $('.page-section').each(function () {
            let elementTop = $(this).offset().top;
            let windowBottom = $(window).scrollTop() + $(window).height();

            // if element is in viewport
            if (windowBottom > elementTop + 100) {
                $(this).addClass('visible');
            }
        });
    }

    // Trigger when scrolling
    $(window).on('scroll', animateSections);

    // Trigger on page load
    animateSections();


    function toggleHeaderClass() {
        if ($(window).scrollTop() > 100) {
            $('header').addClass('scrolled');
        } else {
            $('header').removeClass('scrolled');
        }
    }

    function toggleHeader() {
        function updateHeader() {
            var scrollPosition = $(window).scrollTop();

            $('.page-section').each(function () {
                var $this = $(this);
                var top = $this.offset().top;
                var bottom = top + $this.outerHeight();

                if (scrollPosition >= top && scrollPosition < bottom) {
                    if ($this.data('header') === 'blue') {
                        $('header').addClass('header-blue');
                    } else {
                        $('header').removeClass('header-blue');
                    }
                }
            });
        }

        // Run on scroll
        $(window).on('scroll', updateHeader);

        // ✅ Run once on page load
        updateHeader();
    }

    toggleHeader();


    $(document).ready(toggleHeaderClass);
    $(window).on('scroll', toggleHeaderClass);


    $('.menu-bar').on('click', function () {
        if ($(this).hasClass('menu-bar-active')) {
            $(this).removeClass('menu-bar-active');
            $('.burg-menu').removeClass('burg-menu-active');
        } else {
            $(this).addClass('menu-bar-active');
            $('.burg-menu').addClass('burg-menu-active');
        }
    });

    const $rocket = $('.right-img5');
    const $planet = $('.b-right-img1');
    let lastScrollTop = 0;

    $(window).on('scroll', function () {
        let scrollTop = $(this).scrollTop();

        // how far they move based on scroll
        let translateVal = Math.min(scrollTop / 2, 300);

        // RIGHT movement (existing)
        $rocket.css({
            'transform': `translate3d(${translateVal}px, -${translateVal / 2}px, 0)`,
            'transition': 'transform 0.1s linear'
        });

        // LEFT movement (mirror)
        $planet.css({
            'transform': `translate3d(-${translateVal}px, -${translateVal / 2}px, 0)`,
            'transition': 'transform 0.1s linear'
        });

        lastScrollTop = scrollTop;


    });


    $('#ContactForm .input').focus(function () {
        $('#ContactForm .form-field').removeClass('focused');
        $(this).parent().addClass('focused');
    }).focusout(function () {
        $(this).parent().removeClass('focused');
    });

    let currentLocale = Shopify.locale;
    var langNames = {
        'lt': 'Lietuviškai',
        'en': 'English'
    };
    $('.activelang .lang-name').text(langNames[currentLocale]);

    if ($(window).width() > 1200) {
        var $waveInner = $('#preloader-wave .wave-inner'); // target inner element
        var maxScale = 7;          // final Y scale
        var duration = 1500;       // animation duration in ms (3 seconds)

        // Apply CSS transition for smooth scaling
        $waveInner.css({
            'transition': 'transform ' + duration + 'ms ease',
            'transform': 'scale(1,' + maxScale + ')'
        });

        // Optional: remove wave after animation completes
        setTimeout(function () {
            $('#preloader-wave').fadeOut(500, function() {
                $(this).remove();
            });
        }, duration);
    }

});


